export const COMPOSER_LLM_MODELS = [
  { value: 'openai/gpt-5.6-sol', label: 'GPT 5.6 Sol', provider: 'OpenAI' },
  { value: 'openai/gpt-5.6-terra', label: 'GPT 5.6 Terra', provider: 'OpenAI' },
  { value: 'openai/gpt-5.6-luna', label: 'GPT 5.6 Luna', provider: 'OpenAI' },
  { value: 'openai/gpt-5.5', label: 'GPT 5.5', provider: 'OpenAI' },
  { value: 'openai/gpt-5.4', label: 'GPT 5.4', provider: 'OpenAI' },
  { value: 'amazon-bedrock/global.anthropic.claude-fable-5', label: 'Claude Fable 5', provider: 'Anthropic' },
  { value: 'amazon-bedrock/global.anthropic.claude-opus-5', label: 'Claude Opus 5', provider: 'Anthropic' },
  { value: 'amazon-bedrock/global.anthropic.claude-opus-4-8', label: 'Claude Opus 4.8', provider: 'Anthropic' },
  { value: 'amazon-bedrock/global.anthropic.claude-sonnet-5', label: 'Claude Sonnet 5', provider: 'Anthropic' },
  { value: 'amazon-bedrock/global.anthropic.claude-haiku-4-5-20251001-v1:0', label: 'Claude Haiku 4.5', provider: 'Anthropic' },
];

export const DEFAULT_COMPOSER_LLM_MODEL = COMPOSER_LLM_MODELS[0].value;
